import React from 'react'


export default function Navbar() {
    return (
        <div id="navbar-container">
            <nav className="navbar navbar-light" style= {{backgroundColor: "#1C4E80"}}>
                <div className="container-fluid" >
                    <a style={{color: "white"}} className="navbar-brand" href="#">
                            DATA ANALYTICS
                    </a>
                </div>
            </nav>
        </div>
    )
}
